export function getOperatorSymbol(operator) {
    const dictionary = {
        contains: '=',
        differentThan: '<>',
        fuzzyMatch: '~=',
        greaterThan: '>',
        greaterThanOrEqual: '>=',
        isExactly: '==',
        lowerThan: '<',
        lowerThanOrEqual: '<=',
        phoneticMatch: '%=',
        regexMatch: '/=',
        wildcardMatch: '*=',
    };
    return dictionary[operator];
}
